export default __webpack_public_path__ + "static/media/bookmark.a68024d1.svg";